import { useState, useCallback } from "react";


export const DIALOG_TYPES = {
  SAVE: "save",
  SUBMIT: "submit",
  DELETE: "delete",
  CANCEL: "cancel",
  EXPIRE: "expire",
  FLIP_FLAG: "flipFlag",
};

const INITIAL_DIALOG_STATE = {
  open: false,
  dialogTitle: "",
  dialogContentText: "",
  cancel: "Cancel",
  confirm: "Proceed",
};

export const useDialogStates = () => {
  const [saveState, setSaveState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Proceed",
  });
  
  const [submitState, setSubmitState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Submit",
  });
  
  const [deleteState, setDeleteState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Delete",
  });
  const [cancelState, setCancelState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Cancel",
  });
  const [expireState, setExpireState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Expire",
  });
  const [flipFlagState, setFlipFlagState] = useState({
    ...INITIAL_DIALOG_STATE,
    confirm: "Proceed",
  });


  const closeDialog = useCallback((dialogType) => {
    const setters = {
      [DIALOG_TYPES.FLIP_FLAG]: setFlipFlagState,
      [DIALOG_TYPES.SAVE]: setSaveState,
      [DIALOG_TYPES.SUBMIT]: setSubmitState,
      [DIALOG_TYPES.DELETE]: setDeleteState,
      [DIALOG_TYPES.CANCEL]: setCancelState,
      [DIALOG_TYPES.EXPIRE]: setExpireState,
    };
    
    const setter = setters[dialogType];
    if (setter) {
      setter(prev => ({ ...prev, open: false }));
    }
  }, []);

  return {
    saveState,
    setSaveState,
    submitState,
    setSubmitState,
    deleteState,
    setDeleteState,
    closeDialog,
    cancelState, 
    setCancelState,
    expireState,
    setExpireState,
    flipFlagState,
    setFlipFlagState,
  };
};